import { createIconComponent } from '../../factory/create-icon-component';
export const MalaysiaIcon = createIconComponent(
  'MalaysiaIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33105)">
      <path d="M23 5H1V20H23V5Z" fill="#F0F0F0" />
      <path d="M23 6.87482H1V8.74964H23V6.87482Z" fill="#D80027" />
      <path d="M23 10.6249H1V12.4997H23V10.6249Z" fill="#D80027" />
      <path d="M23 14.3745H1V16.2493H23V14.3745Z" fill="#D80027" />
      <path d="M23 18.1248H1V19.9996H23V18.1248Z" fill="#D80027" />
      <path d="M12 5H1V13.0769H12V5Z" fill="#0052B4" />
      <path
        d="M7.05455 10.8929C6.05304 10.8929 5.24119 10.0626 5.24119 9.03834C5.24119 8.01411 6.05308 7.18378 7.05455 7.18378C7.36681 7.18378 7.66058 7.26455 7.91715 7.40667C7.51475 7.00422 6.9644 6.7558 6.35708 6.7558C5.12448 6.7558 4.12524 7.77774 4.12524 9.03834C4.12524 10.2989 5.12453 11.3209 6.35708 11.3209C6.96436 11.3209 7.51475 11.0725 7.91715 10.67C7.66063 10.8121 7.36681 10.8929 7.05455 10.8929Z"
        fill="#FFDA44"
      />
      <path
        d="M7.56612 7.73395L7.88808 8.42248L8.61511 8.25065L8.28954 8.93733L8.87426 9.41159L8.14624 9.57941L8.1483 10.3426L7.56612 9.8651L6.98393 10.3426L6.98595 9.57941L6.25793 9.41159L6.84265 8.93733L6.51699 8.25065L7.24411 8.42248L7.56612 7.73395Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33105">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
